<template>
	<div class="parameter">
		<div class="header" style="margin-bottom: 10px">
			<el-button type="primary" size="small" @click="editproduct()" >添加</el-button>
      <el-button type="primary" size="small"  @click="dialogVisible1()" style="margin-left: 10px">批量删除</el-button>

			<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="40%" :close-on-click-modal="false">
				<el-form ref="form" :model="form" label-width="80px" size="small">
					<el-form-item label="名称"><el-input v-model="form.editlyAddedName"></el-input></el-form-item>
					<!-- <el-form-item label="值"><el-input v-model="form.editlyAddedAppkey"></el-input></el-form-item> -->

					<el-form-item label="值">
					  <el-input type="textarea" v-model="form.editlyAddedAppkey"></el-input>
					</el-form-item>

					<el-form-item label="分组" >
						<el-select v-model="form.groupId" placeholder="请选择" style="width: 100%;" size="small" :disabled="isdisabledFn">
							<el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="类型">
						<el-select v-model="form.type" placeholder="请选择" style="width: 100%;">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="描述">
					  <el-input type="textarea" v-model="form.desc"></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
					<el-button type="primary" @click="save_parameters()" size="small">确 定</el-button>
				</div>
			</el-dialog>

			<el-input
				class="search"
				size="small"
				placeholder="名称搜索"
				icon="el-icon-eleme"
				v-model="form.querySertitleName"
				@keyup.enter.native="queryterminalparams" :on-icon-click="queryterminalparams"
				width="100"
        style="margin-left: 10px;"
			></el-input>
			<el-input
					class="search"
					size="small"
					placeholder="值搜索"
					icon="el-icon-eleme"
					v-model="form.querySertitleVal"
					@keyup.enter.native="queryterminalparams" :on-icon-click="queryterminalparams"
					width="100"
          style="margin-left: 10px;"
				></el-input>
				<el-select v-model="form.groupIdVal" placeholder="请选择分组" style="width: 150px;margin-left: 10px" size="small" clearable>
					<el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			<el-button type="primary" size="small" @click="queryterminalparams()" style="margin-left: 10px;">搜索</el-button>

			<el-dialog
			  :visible.sync="dialogVisible"
			  width="30%"
			 >
			  <span v-if = 'form.ids == 0'>请选择数据</span>
			  <p style="margin: 0px;height: 40px; line-height: 44px;" v-if = "form.ids != 0">
				  <i class="el-icon-delete-solid" style="font-size: 40px; color:#409EFF;float: left;"></i>
				  <span style="float: left;">确定删除吗？</span>
			  </p>
			  <span slot="footer" class="dialog-footer">
			    <el-button @click="dialogVisible = false"  size="small">取 消</el-button>
			    <el-button type="primary" @click="delparam()"  size="small">确 定</el-button>
			  </span>
			</el-dialog>



			<!-- 分页 -->
			 <el-pagination
				class="paging"
				background
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page.sync="form.pageNo"
				:page-size="form.pageSize"
				layout="total, prev, pager, next"
				:pager-count="5"
				:total="form.totalCount">
			  </el-pagination>
		</div>
		<div :style="{height:tableHeight - 90 +'px'}">
			<el-table
			:maxHeight="tableHeight - 90 + 'px'"
		    size="small"
			ref="multipleTable"
			:data="form.productList"
			tooltip-effect="dark"
			border
			@selection-change="handleSelectionChange = arguments[0]"
		>
			<el-table-column type="selection" width="40" align="center"></el-table-column>
			<el-table-column prop="name" label="名称"></el-table-column>
			<el-table-column property="" label="来源" align="center" width="160">
				<template slot-scope="scope">
					<span v-if="scope.row.referencesId">
						公共组:{{ scope.row.commGroupName }}
					</span>
				</template>
			</el-table-column>
			<el-table-column label="值">
				<template slot-scope="scope">
					{{ scope.row.paramInfo }}
				</template>
			</el-table-column>
			<el-table-column prop="gname" label="分组"></el-table-column>
			<el-table-column label="类型" width="100" align="center">
					 <template scope="scope">
					  <div v-if="scope.row.type == type.STRING.code">string</div>
					  <div v-if="scope.row.type == type.INT.code">int</div>
					  <div v-if="scope.row.type == type.BOOLEAN.code">boolean</div>
                      <div v-if="scope.row.type == type.ARRAY.code">array</div>
					  <div v-if="scope.row.type == type.OBJECT.code">object</div>
					</template>
			</el-table-column>
			<el-table-column prop="paramDesc" label="描述"  width="120" align="center"></el-table-column>
			<el-table-column label="操作" width="120" show-overflow-tooltip align="center">
				<template scope="scope">
					<el-button type="primary" size="small" @click="editproduct(scope.row)">编辑</el-button>
					<!-- <el-button type="primary" size="small">查看</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		</div>
	</div>
</template>

<script>
import constants from '@/js/constants.js'
import api from '@/api/menu/'
import { mapState } from 'vuex';
//添加一个的类型
	const type = constants.type;
export default {
	props: {
		terminalId: {
			type: String
		},
	},
	computed: {
		...mapState('main', ['tableHeight'])
	},
	data() {
		return {
			dialogVisible: false,
			type,
			dialogTitle:'',//添加和编辑
			dialogFormVisible: false,
			isdisabledFn:false,
			form: {
				productList:[],
				gname:'',//组
				editlyAddedName:'',
				editlyAddedAppkey:'',
				querySertitleName:'',
				querySertitleVal:'',
				desc:'',
				groupId:'',
				groupIdVal:'',
				pageSize:15,
				pageNo: 1,//当前页码
				//paginationShow: true,//是否显示分页
				totalCount: 0,//总条数
				token:'',
				id:'',
				ids:[],
				terminalId:'',
				name:"",
				type:"1",
				paramDesc:''
			},
			handleSelectionChange:[],//获取删除的id和token
			formLabelWidth: '120px',
			options1:[],//分组
			options: constants.options
		};
	},
	created() {
	  // this.form.token = this.$cookies.get('USER_TOKEN_COOKIE');
	  this.queryterminalparams()
	  },
	methods: {
		dialogVisible1(){
		   this.dialogVisible = true;
		   this.form.ids = this.handleSelectionChange.map(item => item.id);
		},
		// 删除
		delparam(){
			this.dialogVisible = false;
			var ids = [];
			if(this.form.ids.length == 0){
			    ids = this.form.ids;
			}else{
				ids = this.form.ids;

			var data = {
			  'ids':this.form.ids,
			  'token':this.form.token
			};
			api.delparam(data)
			.then(res => {
				if(res.data.code == 0){
					if(this.form.ids.length == 0){
					}else{
						this.queryterminalparams();
						successMsg({
							   message: '删除成功'
						})
					}
				}else{
					errorMsg({
						   message: res.data.msg
					})
				}
			})
			}
		},
		// 11.9 查询，分组
		querygroup(){
			var data = {
			  'terminalId':this.terminalId,
			  'pageNo':1,
			  'pageSize':10000,
			  // 'token':this.$cookies.get('USER_TOKEN_COOKIE'),
        'groupType':'1'
			};
		 api.querygroup(data)
			.then(res => {
				if(res.data.code == 0){
					this.options1 = res.data.data.list;
				}else{
					errorMsg({
						   message: res.data.msg
					})
				}
			})
		},
		//改变每页显示数量时调用
		  handleSizeChange(val) {
		  this.$nextTick(() =>
		    this.queryterminalparams(),
		  )
		},
		//点击下一页和点击页码时执行
		handleCurrentChange(val) {
		  this.queryterminalparams();
		},
		// 时间格式
		formatCreateDate: function(row) {
		  let createDate = row;
		  return window.formatDate(createDate);
		},
		// // 删除
		// deleteParameter(){
		// 	this.form.ids = this.handleSelectionChange.map(item => item.id);
		// 	var data = {
		// 	  'ids':this.form.ids,
		// 	  'token':this.form.token
		// 	};
		//  api.delproduct(data)
		// 	.then(res => {
		// 		if(res.data.code == 0){
		// 			this.queryterminalparams();
		// 			successMsg({
		// 				   message: '删除成功'
		// 			})
		// 			console.log(res);
		// 		}else{
		// 			errorMsg({
		// 				   message: res.data.msg
		// 			})
		// 		}
		// 	})
		// },
		// 查询项目
		queryterminalparams(){
			this.querygroup();
			this.form.productList = [];
			var data = {
			  'pageNo':this.form.pageNo,
			  'pageSize':this.form.pageSize,
			  'terminalId':this.terminalId,
			  'name':this.form.querySertitleName,
			  'token':this.form.token,
			  'gid':this.form.groupIdVal,
			  'paramInfo':this.form.querySertitleVal
			};
		 api.queryterminalparams(data)
			.then(res => {
				if(res.data.code == 0){
					this.form.productList = res.data.data.list;
					this.form.totalCount = res.data.data.totalSize
				}else{
					errorMsg({
						   message: res.data.msg
					})
				}
			})
		},
		// 编辑
		editproduct(parameter){
			if(parameter){
				this.dialogTitle = "编辑参数";
				this.dialogFormVisible = true;
				this.form.desc = parameter.paramDesc;
				this.form.editlyAddedName = parameter.name;
				this.form.editlyAddedAppkey = parameter.paramInfo;
				this.form.id = parameter.id;
				this.form.type = parameter.type;
				this.form.groupId = parameter.groupId;
				this.isdisabledFn = true;
			}else{
				this.dialogTitle = "添加参数"
				this.dialogFormVisible = true;
				this.form.desc = '';
				this.form.editlyAddedName ='';
				this.form.editlyAddedAppkey = '';
				this.form.id = '';
				this.form.type = "1";
				this.form.groupId = '';
				this.isdisabledFn = false;
			}
		},
		// 添加一个保存
		save_parameters(){

		     if(this.form.id){
				 var data = {
					groupId: this.form.groupId,//分组id
					terminalId: this.terminalId,//所属终端
					type: this.form.type,//单个1 批量2
					token:this.form.token, //用户校验的token
					name: this.form.editlyAddedName,//参数的名称
					paramInfo : this.form.editlyAddedAppkey,//参数的值
					paramDesc : this.form.desc,//参数描述
					id : this.form.id
				 };
				// 编辑
				api.editparam(data)
					.then(res => {
						if(res.data.code == 0){
							 this.queryterminalparams();
							successMsg({
								   message: '保存成功'
							})
							this.form.desc = '';
							this.form.editlyAddedName ='';
							this.form.editlyAddedAppkey = '';
							this.form.id = '';
							this.form.type = 1;
							this.form.groupId = '';
							this.dialogFormVisible = false;
						}else{
								errorMsg({
									message: res.data.msg
								})
								this.dialogFormVisible = true;
						}
					})
			 }else{

           if(this.form.groupId == "" || this.form.editlyAddedName == "" ||
             this.form.editlyAddedAppkey ==""){
             errorMsg({
               message: "请输入名称、值、分组信息!"
             })
             return;
           }
				 var data = {
					groupId: this.form.groupId,//分组id
					terminalId: this.terminalId,//所属终端
					type: 1,//单个1 批量2
					token:this.form.token, //用户校验的token
					params:[
						{
							name: this.form.editlyAddedName,//参数的名称
							paramInfo : this.form.editlyAddedAppkey,//参数的值
							type: this.form.type,// 类型  1:int 2:string 3:boolean
							paramDesc : this.form.desc,//参数描述
						}
					]
				 };
				 // 添加
				api.saveparam(data)
					.then(res => {
						if(res.data.code == 0){
							console.log(res);
							 this.queryterminalparams();
							successMsg({
								   message: '添加成功'
							})
							this.form.desc = '';
							this.form.editlyAddedName ='';
							this.form.editlyAddedAppkey = '';
							this.form.id = '';
							this.form.type = 1;
							this.form.groupId = '';
							this.dialogFormVisible = false;
						}else{
							console.log(res.data.msg);
							errorMsg({
								   message: res.data.msg
							})
							this.dialogFormVisible = true;
						}
					})
			 }
		},
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.parameter {
	.crumbs {
		margin-top: 10px;
	}
	.header {
		position: relative;
		// height: 60px;
		// line-height: 60px;
        .paging{
			position: absolute;
			right: 0px;
			top: 0px;
		}
		.search {
			width: 200px;
		}
	}
	.a {
		cursor: pointer;
	}
}
</style>
